const selectors = {
  headings: '.product-info__tab-heading',
  bodies: '.product-info__tab-body'
}

const tabHeadings = document.querySelectorAll(selectors.headings);
const tabBodies = document.querySelectorAll(selectors.bodies);

function tabResize() {
  if (tabBodies.lenght === 0) return;

  const currentTab = document.querySelector('.product-info__tab-body[data-tab-hidden="false"]');
  const contentHeight = document.querySelector('.product-info__tab-body[data-tab-hidden="false"] > :first-child');

  if (contentHeight && currentTab) {
    const currentTabHeight = contentHeight.scrollHeight;
    setTimeout(() => {
      currentTab.style.height = currentTabHeight + 'px';
    }, 0);
  }
}

function tabHandler() {
  if (!tabHeadings || !tabBodies) return;

  tabHeadings.forEach(function (tabHeading) {
    // Set initial height to first opened tab for animation
    tabBodies.forEach(tabBody => {
      if (tabBody.dataset.tabHidden === 'false') {
        tabBody.style.height = tabBody.clientHeight + 'px';
      }
    })

    tabHeading.addEventListener('click', function () {
      const tabNumber = this.getAttribute('data-tab');

      tabHeadings.forEach(heading => {
        heading.dataset.selected = 'false';
      });

      this.dataset.selected = 'true';

      tabBodies.forEach(function (tabBody) {
        tabBody.dataset.tabHidden = 'true';
      });

      const currentTab = document.querySelector('.product-info__tab-body[data-tab="' + tabNumber + '"]');
      currentTab.parentNode.style.backgroundColor = currentTab.dataset.background;
      currentTab.dataset.tabHidden = 'false';
      const currentTabHeight = currentTab.scrollHeight;
      setTimeout(() => {
        currentTab.style.height = currentTabHeight + 'px';
      }, 0);
    });
  });
}

tabHandler();
window.addEventListener('resize', tabResize);